<div class="grid grid-cols-12 gap-4">
  @for (button of layerButtons; track $index) {
    <div class="col-span-6">
      <p-button severity="secondary" [label]="button.label" styleClass="w-full !capitalize" (onClick)="button?.command()" />
    </div>
  }
</div>
